import React, { useEffect } from 'react';
import './Industries.css';

const industries = [
  {
    name: 'Asset & wealth management',
    items: ['— Portfolio platforms', '— Advisor & RIA tooling', '— Model marketplaces', '— Client reporting']
  },
  {
    name: 'Capital markets & banking',
    items: ['— Trading & execution', '— Treasury systems', '— Post-trade & settlement', '— Corporate banking']
  },
  {
    name: 'Hedge funds & prop trading',
    items: ['— Research environments', '— Strategy deployment', '— Risk & PnL attribution', '— Alt-data integration']
  },
  {
    name: 'Fintech & embedded finance',
    items: ['— Payment rails', '— Lending platforms', '— Card programmes', '— BaaS infrastructure']
  },
  {
    name: 'Insurance & pensions',
    items: ['— Underwriting workflows', '— Policy administration', '— Claims orchestration', '— Member portals']
  },
  {
    name: 'Digital assets & market infra',
    items: ['— Custody integrations', '— Tokenised funds', '— Exchange tooling', '— On-chain compliance']
  },
  {
    name: 'Government & enterprise',
    items: ['— Internal tooling', '— Citizen services', '— Data platforms', '— Workflow automation']
  },
  {
    name: 'SaaS & growth-stage product',
    items: ['— Multi-tenant platforms', '— Customer portals', '— Mobile applications', '— Re-platforming']
  },
  {
    name: 'Healthcare, legal & regulated',
    items: ['— Practice management', '— Compliance workflows', '— Secure document handling', '— Audit-grade systems']
  }
];

export default function Industries() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="section-wrapper--ivory">
      <section className="section shell" id="industries">
      <div className="cases-head" style={{ alignItems: 'center' }}>
        <div>
          <div className="section-label reveal">05 — Industries</div>
          <h2 className="display cases-head__title reveal" style={{ marginTop: '32px' }}>
            Where we<br /><em style={{ color: 'rgba(14, 14, 12, 0.5)' }}>operate.</em>
          </h2>
        </div>
        <p className="cases-head__sub reveal" style={{ textAlign: 'center' }}>
          Four years building production systems across regulated and consumer environments. Our teams understand the workflows, the audit trail, and the cost of a release that misbehaves at scale.
        </p>
      </div>

      <div className="industries">
        {industries.map((industry, idx) => (
          <div key={idx} className="industry reveal">
            <div className="industry__num">/ I.{String(idx + 1).padStart(2, '0')}</div>
            <div className="industry__name">{industry.name}</div>
            <div className="industry__items">
              {industry.items.map((item, i) => (
                <span key={i}>{item}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
      </section>
    </div>
  );
}
